import styled from 'styled-components';
export var Amount = styled.div.withConfig({
  displayName: "elements__Amount",
  componentId: "sc-16wytyu-0"
})(["color:", ";text-align:end;"], function (_ref) {
  var palette = _ref.theme.palette;
  return palette.primary["default"];
});
export var Container = styled.li.withConfig({
  displayName: "elements__Container",
  componentId: "sc-16wytyu-1"
})(["align-items:center;background-color:white;display:flex;height:5.2rem;justify-content:space-between;padding:0 2rem;&:not(:first-child){border-top:1px solid ", ";}"], function (_ref2) {
  var palette = _ref2.theme.palette;
  return palette.mysticGrey;
});
export var Evolution = styled.div.withConfig({
  displayName: "elements__Evolution",
  componentId: "sc-16wytyu-2"
})(["color:", ";font-size:", ";font-weight:", ";text-align:end;"], function (_ref3) {
  var evolution = _ref3.evolution,
      palette = _ref3.theme.palette;
  return evolution > 0 ? palette.success["default"] : evolution < 0 ? palette.failure["default"] : palette.mediumGrey;
}, function (_ref4) {
  var fonts = _ref4.theme.fonts;
  return fonts.size["default"];
}, function (_ref5) {
  var fonts = _ref5.theme.fonts;
  return fonts.weight.normal;
});
export var Label = styled.span.withConfig({
  displayName: "elements__Label",
  componentId: "sc-16wytyu-3"
})(["color:", ";font-weight:", ";"], function (_ref6) {
  var palette = _ref6.theme.palette;
  return palette.darkBlue;
}, function (_ref7) {
  var fonts = _ref7.theme.fonts;
  return fonts.weight.thick;
});
export var SideWrapper = styled.div.withConfig({
  displayName: "elements__SideWrapper",
  componentId: "sc-16wytyu-4"
})(["display:flex;flex-direction:column;"]);